module.exports = __webpack_public_path__ + "static/media/logo.5245f4a1.png";